import React, { useState, useEffect } from "react";
import { Heading } from "../../CommonComponent/heading";
// import MonthlyAttendenceModle from "./MonthlyAttendenceModle/MonthlyAttendenceModle";
import Swal from "sweetalert2";
import { AttendenceReportAPI } from "../../../api/Payroll/AttendenceReport";
import useLoading from "../../CommonComponent/useLoading";
import useLocalStorageData from "../Comman/LocalStorageData";
import Loader from "../../Loader/Loader";
//import ReactHTMLTableToExcel from "react-html-table-to-excel";
//import { jsPDF } from "jspdf";
//import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";

const AttendenceReport = () => {
  const [Date1, setDate1] = useState("");

  const { school_id, token, school_emp_id } = useLocalStorageData();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [attendanceData, setAttendanceData] = useState([]);
  const [SearchFilter, setSearchFilter] = useState(false);
  const [isDaily, setIsDaily] = useState(false);

  const { user_detail } = useLocalStorageData();
  const schoolName = user_detail?.school_name || "School Name";

  const handelDateChange = (e) => {
    setDate1(e.target.value);
  };

  const hanleClear = () => {
    setDate1("");
    setAttendanceData([]);
    setFilteredData([]);
    setIsDaily(false);
  };

  const getEmployList = async () => {
    setAttendanceData([]);
    setFilteredData([]);
    if (!Date1) {
      Swal.fire({
        text: "Please select month and year",
        icon: "error",
        allowOutsideClick: false,
      });
      return;
    }
    try {
      let data = {
        school_id: school_id,
        attendance_month: Date1,
        is_attendance: isDaily ? "Daily" : "Month",
      };

      startLoading();
      const response = await AttendenceReportAPI.inOutTimeReportArr(data);
      const responseData = response.data;
      if (responseData.status === 200) {
        setAttendanceData(responseData.result);
        setFilteredData(responseData.result);
        setSearchFilter(true);
      } else {
        Swal.fire({
          text: responseData.msg,
          icon: "error",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      stopLoading();
    }
  };

  /* const handleExportPDF = async () => {
    const input = document.getElementById("table-to-xls"); // same table id you already use
    if (!input) return;

    const pdf = new jsPDF("l", "pt", "a4"); // landscape, points, A4
    const canvas = await html2canvas(input, {
      scale: 2, // high quality
    });
    const imgData = canvas.toDataURL("image/png");

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`AttendanceReport_${Date1}.pdf`);
  }; */

  //function to print PDF for monthly report

  const handleOpenMonthlyReport = () => {
    if (filteredData.length === 0) return;

    const currentDate = new Date();
    const generatedOn = currentDate.toLocaleString();

    const monthStart = new Date(Date1 + "-01");
    const monthEnd = new Date(
      monthStart.getFullYear(),
      monthStart.getMonth() + 1,
      0
    );

    // ✅ Always include 31 days for uniform layout
    const datesInMonth = [];
    for (let d = 1; d <= 31; d++) {
      datesInMonth.push(d);
    }


// ✅ Custom date formatter: "MonthName Day, Year"
const formatFullDate = (date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

// ✅ Reformat monthStart / monthEnd
const formattedMonthStart = formatFullDate(monthStart);
const formattedMonthEnd = formatFullDate(monthEnd);

const now = new Date(); // captures current timestamp
const weekday = now.toLocaleDateString("en-US", { weekday: "long" }); // e.g., "Monday"

// ✅ Reformat generatedOn
const formattedGeneratedOn = `${weekday.charAt(0).toUpperCase() + weekday.slice(1)}, ${now.toLocaleString("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
})
.replace(" at", " ")}`;



    const reportHtml = `

   <div style="border: 2px solid black; padding: 6px; margin: 4px;">
  <div id="pdf-report" style="font-family: Arial, sans-serif; padding: 10px; page-break-inside: avoid; width: 100%; ">
    <h2 style="text-align:center;">${schoolName}</h2>
    <h4 style="text-align:center; margin-bottom:10px; font-weight:bold; font-size:medium">Monthly Status Report(Work Duration)</h4>
      <div style="text-align:center; margin-bottom:10px; font-weight:bold; font-size:medium">From: ${formattedMonthStart} To ${formattedMonthEnd}</div>
        <div style="display:flex; justify-content:end; margin-bottom:30px;">
          <div><span style="font-weight:bold">Generated on:</span> ${formattedGeneratedOn}</div>
    </div>

    ${filteredData
      .map((staff) => {
        /* const presentDays = staff.attendance.filter(a => a.status === "Present").length;
        const absentDays = staff.attendance.filter(a => a.status === "Absent").length;
        const holidays = staff.attendance.filter(a => a.status === "Holiday").length;
 */
        return `
        <div style="margin-bottom:34px; page-break-inside: avoid;">
          <div style="font-weight:bold; margin-bottom:5px;">
            Employee Name : ${staff.first_name} ${staff.last_name}, 
            Employee Code : ${staff.emp_code}, 
            Present Days : ${staff.present_count}, 
            Absent : ${staff.absent_count}, 
            Holidays : ${staff.holiday_count}
          </div>

          <div style="overflow-x:auto;"> 
          <table style="width:max-content; table-layout:auto; border-collapse:collapse; font-size:9px; ">
  <colgroup>
    <col style="width:7%;" /> <!-- Column 1: Label (Date / Status / In / Out / Total) -->
    ${datesInMonth.map(() => `<col style="width:32px;" />`).join("")}
  </colgroup>

  <thead>
    <tr>
      <th style="border:1px solid #000;  background:#f2f2f2; font-weight:bold;">Date</th>
      ${datesInMonth
        .map(
          (d) =>
            `<th style="border:1px solid #000;  background:#f2f2f2;">${d}</th>`
        )
        .join("")}
    </tr>
  </thead>

  <tbody>
    ${["Status", "In", "Out", "Total"]
      .map((label) => {
        return `
        <tr style="height:auto;">
          <td style="border:1px solid #000; background:#f9f9f9; font-weight:bold;">${label}</td>
         ${datesInMonth
           .map((d) => {
             const record = staff.attendance.find(
               (a) => new Date(a.attendance_date).getDate() === d
             );

             let value = "--";
             if (label === "Status")
               value = record?.status ? record.status[0] : "--";
             if (label === "In" && record?.in_time)
               value = record.in_time.split(":").slice(0, 2).join(":");
             if (label === "Out" && record?.out_time)
               value = record.out_time.split(":").slice(0, 2).join(":");
             if (label === "Total") value = record?.working_hours || "--";

             // ✅ Apply fixed width only if the cell is empty ("--")
             const tdStyle =
               value === "--"
                 ? "border:1px solid #000; width:25px; text-align:center;"
                 : "border:1px solid #000; text-align:center;";

             return `<td style="${tdStyle}">${value}</td>`;
           })
           .join("")}

        </tr>
        `;
      })
      .join("")}
  </tbody>
</table>
</div>

        </div>
        `;
      })
      .join("")}
  </div>
  </div>
  `;

    // ✅ Create a temporary element for rendering
    const element = document.createElement("div");
    element.innerHTML = reportHtml;

    // ✅ html2pdf options
    const opt = {
      margin: [0.2, 0.2, 0.2, 0.2],
      filename: `Monthly_Attendance_Report_${monthStart.toLocaleDateString()}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 2, // keeps text sharp
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: 2200, // ensures table fits full width
      },
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    };

    html2pdf().set(opt).from(element).save();
  };

  // to print PDF for daily report


const formatDate = (dateString) => {
  if (!dateString) return "--";
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};


  const handleOpenDailyReport = () => {
    if (filteredData.length === 0) return;

    const currentDate = new Date();
    

    const reportHtml = `
    <div style="border: 2px solid black; padding: 0px; margin: 4px;">
      <div id="pdf-report" style="font-family: Arial, sans-serif; padding: 0px; width: 100%;">
        <h1 style="text-align:center;">${schoolName}</h1>
        <div> -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------</div>
        <h4 style="text-align:center; margin-bottom:10px; font-weight:bold; font-size:20px"> Attendance Report</h4>
       
      <div style="width:100%; border-bottom:3px solid black; margin-bottom:8px"> </div>

        <div style="overflow-x:auto;">
         <div style="text-align:start; margin-bottom:0px; font-size:medium"><span style="font-weight:bold;" >Date:</span> ${formatDate(Date1)}</div>
          <table style="width:100%; border-collapse:collapse; font-size:16px;" border="3 black">
            <thead>
              <tr>
                <th>Employee Code</th>
                <th>Name</th>
                <th>In Time</th>
                <th>Out Time</th>
                <th>Working Hours</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
                .map((staff) => {
                  const record = staff.attendance[0]; // only one record for daily
                  return `
                  <tr>
                    <td>${staff.emp_code}</td>
                    <td>${staff.first_name} ${staff.last_name}</td>
                    <td>${record?.in_time || "--"}</td>
                    <td>${record?.out_time || "--"}</td>
                    <td>${record?.working_hours || "--"}</td>
                  </tr>
                `;
                })
                .join("")}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `;

    const element = document.createElement("div");
    element.innerHTML = reportHtml;

    const opt = {
      margin: [0.2, 0.2, 0.2, 0.2],
      filename: `Daily_Attendance_Report_${Date1}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: 2200,
      },
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    };

    html2pdf().set(opt).from(element).save();
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(attendanceData);

  const handleSearch = () => {
    if (searchQuery.trim() === "") {
      setFilteredData(attendanceData);
      return;
    }
    const query = searchQuery.toLowerCase();
    const result = attendanceData.filter((staff) =>
      `${staff.first_name.toLowerCase()} ${staff.last_name.toLowerCase()}`.includes(
        query
      )
    );
    setFilteredData(result);
  };
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(attendanceData);
    }
  }, [searchQuery, attendanceData]);
  if (isLoading) return <Loader />;

  return (
    <div className="container-fluid">
      <Heading pageTitle={"Attendence Report"}></Heading>

      <div className="card mt-2">
        <div className="card-body">
          <div className="col-lg-12 row form-group ">
            <div className="col-auto">
              <label className="col-form-label ">Daily Report</label>
            </div>
            <div className=" col-auto align-self-center">
              <label className="custom-switch">
                <input
                  type="checkbox"
                  className="custom-switch-input "
                  name="custom-switch-checkbox"
                  id="smsCheckbox"
                  onChange={() => setIsDaily(!isDaily)}
                  checked={isDaily}
                />
                <span className="custom-switch-indicator mr-3"></span>
              </label>
            </div>
            <div className="col-auto ">
              <label className="col-form-label ">
                {isDaily ? "Date" : "Month & Year"}
              </label>
            </div>
            <div className="col-auto">
              <input
                type={isDaily ? "date" : "month"}
                className="form-control"
                placeholder="Month & Year"
                value={Date1}
                onChange={handelDateChange}
              />
            </div>
            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary mx-1"
                type="button"
                onClick={getEmployList}
              >
                <i className="fa fa-eye"> </i> View
              </button>
            </div>
            <div className="input-group-append">
              {filteredData.length > 0 ? (
                <button
                  className="btn btn-primary btn-sm"
                  type="button"
                  onClick={
                    isDaily ? handleOpenDailyReport : handleOpenMonthlyReport
                  }
                >
                  <i className="fa fa-file-pdf-o" aria-hidden="true"></i> EXPORT
                  to PDF
                </button>
              ) : null}
            </div>

            <div className="input-group-append">
              <button
                className="btn btn-outline-danger mx-1"
                type="button"
                onClick={hanleClear}
              >
                <i className="fa fa-times"></i> Clear
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-2">
        <div class="card-header">
          <h3 class="card-title">Employee List</h3>
        </div>
        <div className="card-body">
          <div className="row">
            {SearchFilter && (
              <>
                <div className="col-4 ">
                  <input
                    type="text"
                    placeholder="Search by name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="form-control"
                  />
                </div>
                <button onClick={handleSearch} className="btn btn-primary ">
                  Search
                </button>
                {/* new changes */}
              </>
            )}
          </div>
          <div className="table-responsive mt-2">
            {isDaily ? (
              <>
                <table
                  className="table table-bordered text-center"
                  style={{ border: "1px solid #dee2e6", width: "100%" }}
                  id="table-to-xls"
                >
                  <thead>
                    {/* Date Row */}
                    <tr>
                      <th
                        colSpan="5"
                        style={{
                          textAlign: "left",
                          padding: "8px",
                          fontSize: "16px",
                          backgroundColor: "#f2f2f2",
                          color: "#333",
                        }}
                      >
                        Date:{" "}
                        {filteredData[0]?.attendance[0]?.attendance_date ||
                          "--"}
                      </th>
                    </tr>

                    {/* Header Row */}
                    <tr>
                      <th style={{ width: "15%" }}>Employee Code</th>
                      <th style={{ width: "25%" }}>Name</th>
                      <th style={{ width: "20%" }}>In Time</th>
                      <th style={{ width: "20%" }}>Out Time</th>
                      <th style={{ width: "20%" }}>Working Hours</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((staff) => {
                        const record = staff.attendance[0]; // assuming only one attendance record per staff
                        return (
                          <tr key={staff.fk_staff_id}>
                            <td>{staff.emp_code}</td>
                            <td>
                              {staff.first_name} {staff.last_name}
                            </td>
                            <td>{record.in_time ? record.in_time : "--"}</td>
                            <td>{record.out_time ? record.out_time : "--"}</td>
                            <td>
                              {record.working_hours
                                ? record.working_hours
                                : record.in_time || record.out_time
                                ? "--"
                                : "--"}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          style={{ textAlign: "center", fontSize: "18px" }}
                        >
                          No data found{" "}
                          {searchQuery ? "for " + searchQuery : ""}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            ) : (
              <>
                <table
                  className="table table-hover table-vcenter table-sm table-striped text-nowrap"
                  id="table-to-xls"
                >
                  <thead>
                    <tr>
                      <th>Attendance Date</th>
                      <th>In Time</th>
                      <th>Out Time</th>
                      <th>Working Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((staff) => (
                        <React.Fragment key={staff.fk_staff_id}>
                          <tr className="text-white bg-lightgray">
                            <td colSpan="4" style={{ fontWeight: "bold" }}>
                              <h6 className="m-auto p-2">
                                {staff.first_name + " " + staff.last_name}
                              </h6>
                            </td>
                          </tr>
                          {staff.attendance.map((record, index) => (
                            <tr key={index}>
                              <td>{record.attendance_date}</td>
                              <td>{record.in_time || "--"}</td>
                              <td>{record.out_time || "--"}</td>
                              <td>
                                {record.working_hours == 0
                                  ? "--"
                                  : record.working_hours}
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          style={{ textAlign: "center", fontSize: "2.5rem" }}
                          className="no-list-message"
                        >
                          {" "}
                          No data found{" "}
                          {searchQuery ? "for " + searchQuery : ""}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendenceReport;
